import { t as tr } from '@hana/i18n';
import './MatchPad.i18n';
import { useState } from 'react';
import { IconLink, IconPlus, IconUnlink } from '@tabler/icons-react';
import { Button, useToast } from '@hana/ui';
import { MATCH_LINES, selectedLine, type MatchConf } from './costingMatch';

/** Mint-Cost-iPad ghi lý do đầy đủ hơn bản desktop (cùng dữ liệu mẫu). */
const PAD_WHY: Readonly<Record<string, string>> = {
  'khớp số cont': 'Khớp số cont · lệch 0,2 tr',
  'khớp cont, lệch 0,6': 'Khớp cont, lệch 0,6 tr',
  'cùng ngày hạ': 'Cùng ngày hạ bãi',
  'khớp cont, số ngày cắm điện': 'Khớp cont và số ngày cắm điện',
  'khớp biển số + giờ GPS': 'Khớp biển số + giờ GPS',
};
import { f1 } from './view';
import { useT } from '@hana/i18n';
import s from './matchPad.module.css';
import './finance.i18n';

// Mint-Cost-iPad › tab Hàng chờ ghép: dải đếm · 2 cột (dòng HĐ đối tác | dòng chi dự kiến cho dòng đang chọn). Chỉ đọc; nút ghi báo toast.

const NO_DONE: ReadonlySet<number> = new Set();
const DONE_TODAY = 38;
const CONF_TONE: Record<MatchConf, string | undefined> = { Cao: s.cOk, Vừa: s.cWarn, Thấp: s.cGray };

export function MatchPad() {
  const toast = useToast();
  const tx = useT();
  const [sel, setSel] = useState<number | null>(null);
  const noWrite = () => toast({ msg: 'Chưa mở ghi ở bản này' });
  const cur = selectedLine(MATCH_LINES, NO_DONE, sel);
  const cands = cur === null ? [] : MATCH_LINES[cur]![5];

  return (
    <>
      <div className={s.strip}>
        <span className={s.warn} title="Dòng HĐ chưa ghép" aria-label={`${MATCH_LINES.length} dòng HĐ chưa ghép`}>
          <IconUnlink size={15} aria-hidden="true" />
          {MATCH_LINES.length} chưa ghép
        </span>
        <span className={s.ok} title="Đã ghép hôm nay" aria-label={`Đã ghép hôm nay ${DONE_TODAY}`}>
          <IconLink size={15} aria-hidden="true" />
          {DONE_TODAY} hôm nay
        </span>
      </div>
      <div className={s.grid}>
        <section className={s.card} aria-label="Dòng hoá đơn">
          <h2>{tx('fn.mpInv')}</h2>
          {MATCH_LINES.map((l, i) => (
            <button key={`${l[1]}-${l[0]}`} type="button" className={s.line} aria-pressed={cur === i} onClick={() => setSel(i)}>
              <div className={s.lt}>
                <div className={s.name}>{l[0]}</div>
                <div className={s.sub}>
                  HĐ {l[1]} · {l[2]}
                </div>
                <div className={s.ref}>{l[3]}</div>
              </div>
              <b>{f1(l[4])} tr</b>
            </button>
          ))}
        </section>
        <section className={`${s.card} ${s.sticky}`} aria-label="Dòng dự kiến">
          <h2>{tx('fn.mpPlan')}</h2>
          <div className={s.for}>cho: {cur === null ? '—' : MATCH_LINES[cur]![0]}</div>
          {cands.map(([job, svc, code, exp, why, conf]) => (
            <div key={`${job}-${code}`} className={s.cand}>
              <div className={s.ct}>
                <b>{job}</b>
                <span className={`${s.conf} ${CONF_TONE[conf]}`}>Tin cậy {conf.toLowerCase()}</span>
              </div>
              <div className={s.csub}>
                {svc} · {code} · dự kiến {exp} tr
              </div>
              <div className={s.why}>{PAD_WHY[why] ?? why}</div>
              <Button variant="primary" className={s.go} icon={<IconLink size={16} aria-hidden="true" />} onClick={noWrite}>
                {tr('mpad.1')}
              </Button>
            </div>
          ))}
          {cur !== null && cands.length === 0 && <div className={s.none}>{tx('fn.mpNone')}</div>}
          <div className={s.acts}>
            <Button icon={<IconPlus size={16} aria-hidden="true" />} onClick={noWrite}>
              {tr('mpad.2')}
            </Button>
            <button type="button" className={s.ask} onClick={() => toast({ msg: 'Hỏi Hana chưa mở ở bản này' })}>
              {tr('mpad.3')}
            </button>
          </div>
        </section>
      </div>
    </>
  );
}
